import { Component } from 'react';
import roles, { ROLE_SHOW_VARIANT } from 'helpers/roles';
import moment from 'moment';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { connect } from 'react-redux';
import axios from 'helpers/gastro';
import { combineStyles, isGranted } from 'helpers/helpers';
import { isDatepickerValidDay } from 'helpers/dateHelpers';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import { Dialog, DialogContent } from '@material-ui/core';
import { fetchVariants } from 'actions/Variants';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';
import CardWrapper from 'components/Card/CardWrapper';
import { toast } from 'react-toastify';
import { apiErrorToast } from 'utils/apiError';
import DEFAULT_SALES_MARKET_LANG from 'constants/defaultSalesMarketLang';

import MIME_TYPES from './constants/mimeTypes';
import ReportPreview from './ReportPreviev/ReportPreview';
import SelectInput from '../../components/FormSelect/SelectInput';
import Archive from '../../components/Archive/Archive';
import AccessDenied from '../../components/Security/AccessDenied';
import BaseBrandAndDateReport from './BaseBrandReport';

class MacroIngredients extends Component {
  url = 'reports/macro-ingredients';

  state = {
    variant: '',
    date: '',
    isGenerating: false,
    isGeneratingPreview: false,
    excelContent: {},
    isReportPreviewOpen: false,
  };

  getFileName = getReportFileName(
    this.props.t('reports.reportMacroIngredients')
  );

  componentDidMount() {
    this.props.fetchVariants();
  }

  validateDate = () => this.state.date;

  validateVariant = () => this.state.variant;

  handleSelectChange = (event, value) => {
    this.setState(() => ({
      variant: value,
    }));
  };

  // eslint-disable-next-line consistent-return -- FIXME
  handlePreviewGenerate = () => {
    this.setState({ isGeneratingPreview: true });

    if (!this.validateVariant()) {
      this.setState({ isGeneratingPreview: false });

      return toast.error(this.props.t('reports.selectVariant'));
    }

    if (!this.validateDate()) {
      this.setState({ isGeneratingPreview: false });

      return toast.error(this.props.t('errors.reportRequiresDate'));
    }

    axios
      .get(this.url, {
        responseType: 'blob',
        params: {
          variant: this.state.variant.id,
          date: this.state.date,
        },
        headers: { accept: MIME_TYPES.json },
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        async response => {
          if (response.data) {
            const text = await response.data.text();
            const excelContent = JSON.parse(text);

            this.setState({
              excelContent,
              isGeneratingPreview: false,
              isReportPreviewOpen: true,
            });
          } else {
            alert(this.props.t('reports.noAccess'));
            this.setState({ isGeneratingPreview: false });
          }
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(this.props.t('reports.cannotGenerate'), error);
          this.setState({ isGeneratingPreview: false });
        }
      )
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .finally(() => {
        this.setState({ isGeneratingPreview: false });
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, consistent-return -- FIXME
  handleGenerate = title => {
    this.setState({ isGenerating: true });

    if (!this.validateVariant()) {
      this.setState({ isGenerating: false });

      return toast.error(this.props.t('reports.selectVariant'));
    }

    if (!this.validateDate()) {
      this.setState({ isGenerating: false });

      return toast.error(this.props.t('reports.selectDate'));
    }

    const params = {
      variant: this.state.variant.id,
      date: this.state.date,
    };

    axios
      .get(this.url, {
        responseType: 'blob',
        params,
        headers: { accept: MIME_TYPES.xlsx },
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `${this.getFileName(this.state)}.xlsx`
            );

            document.body.appendChild(link);
            link.click();
            this.setState({ isGenerating: false });
          } else {
            alert(this.props.t('reports.noAccess'));
            this.setState({ isGenerating: false });
          }
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(this.props.t('reports.cannotGenerate'), error);
          this.setState({ isGenerating: false });
        }
      )
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .finally(() => {
        this.setState({ isGenerating: false });
      });
  };

  render() {
    const { classes, t, variants } = this.props;
    const {
      date,
      excelContent,
      isGenerating,
      isGeneratingPreview,
      isReportPreviewOpen,
      variant,
    } = this.state;

    return isGranted(roles.ROLE_SHOW_REPORT_MACRO_INGREDIENTS) ? (
      <>
        <CardWrapper title={t('reports.reportMacroIngredients')}>
          <Dialog open={isGenerating || isGeneratingPreview}>
            <DialogContent>
              <div style={{ textAlign: 'center' }}>
                <h1>{t('reports.generate')}</h1>
                <CircularProgress />
              </div>
            </DialogContent>
          </Dialog>
          <CardBody>
            <GridContainer justify="center">
              {isGranted(ROLE_SHOW_VARIANT) && (
                <GridItem sm={4}>
                  <SelectInput
                    classes={classes}
                    // eslint-disable-next-line no-shadow -- FIXME
                    options={variants.filter(variant => variant.active)}
                    mapBy="name"
                    trackBy="@id"
                    value={variant}
                    handleChange={this.handleSelectChange}
                    label={t('reports.selectVariant')}
                  />
                </GridItem>
              )}
              <GridItem sm={4}>
                <FormLabel
                  className={classes.labelHorizontal}
                  style={{ marginBottom: '5px' }}
                >
                  {this.props.t('reports.selectDate')} *
                </FormLabel>
                <FormControl fullWidth={true}>
                  <Datetime
                    isValidDate={isDatepickerValidDay}
                    timeFormat={false}
                    dateFormat={moment.localeData().longDateFormat('L')}
                    closeOnSelect={true}
                    // eslint-disable-next-line new-cap -- FIXME
                    value={new moment(date)}
                    onChange={e =>
                      this.setState({ date: e.format('YYYY-MM-DD') })
                    }
                    inputProps={{ readOnly: true }}
                  />
                </FormControl>
              </GridItem>
              <GridItem>
                <Button
                  onClick={this.handlePreviewGenerate}
                  disabled={isGenerating || isGeneratingPreview}
                  color="info"
                  round={true}
                >
                  {this.props.t('reports.previewXlsx')}
                </Button>
                <Button
                  onClick={this.handleGenerate}
                  disabled={isGenerating || isGeneratingPreview}
                  color="success"
                  round={true}
                >
                  {t('reports.gReport')}
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </CardWrapper>
        <Card>
          <CardBody>
            <Archive
              type={['REPORT']}
              reportName={['MACRO_INGREDIENTS']}
              options={{
                variants,
              }}
            />
          </CardBody>
        </Card>
        <ReportPreview
          date={date}
          dateType={this.dateType}
          excelContent={excelContent}
          isOpen={isReportPreviewOpen}
          selectedVariant={variant}
          title={t('reports.reportMacroIngredients')}
          useVariants={true}
          handleGenerate={() => {
            this.handleGenerate(MIME_TYPES.xlsx, DEFAULT_SALES_MARKET_LANG);
          }}
          onClose={() => {
            this.setState({ isReportPreviewOpen: false });
          }}
        />
      </>
    ) : (
      <AccessDenied />
    );
  }
}

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const mapStateToProps = state => ({
  variants: state.Variants.variants,
});

const mapDispatchToProps = {
  fetchVariants,
};

BaseBrandAndDateReport.propTypes = {
  brands: PropTypes.array,
  classes: PropTypes.any,
  fileName: PropTypes.func.isRequired,
  mimeType: PropTypes.string.isRequired,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(),
  withStyles(combinedStyles)
);

export default enhance(MacroIngredients);
